import React from 'react';

export const AttendeesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 3.33333C0 1.49238 1.49238 0 3.33333 0H16.6667C18.5076 0 20 1.49238 20 3.33333V16.6667C20 18.5076 18.5076 20 16.6667 20H3.33333C1.49238 20 0 18.5076 0 16.6667V3.33333Z"
        fill="#333333"
      />
      <path
        d="M10.0207 14.4086L5.61176 9.99972L10.0207 5.59082L14.4287 9.99972L10.0207 14.4086ZM6.7591 10.0001L10.0207 13.2609L13.2814 10.0002L10.0207 6.73858L6.7591 10.0001Z"
        fill="white"
      />
      <path
        d="M7.45639 14.1221L3.33464 10.0003L7.45639 5.87817L8.03027 6.45205L4.48241 10.0003L8.03027 13.5478L7.45639 14.1221Z"
        fill="white"
      />
      <path
        d="M12.5433 14.1221L11.9694 13.5478L15.5173 10.0003L11.9694 6.45205L12.5433 5.87817L16.665 10.0003L12.5433 14.1221Z"
        fill="white"
      />
    </svg>
  );
};
